import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Plus_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.5C12.5523 2.5 13 2.94772 13 3.5V11L20.5 11C21.0523 11 21.5 11.4477 21.5 12C21.5 12.5523 21.0523 13 20.5 13L13 13V20.5C13 21.0523 12.5523 21.5 12 21.5C11.4477 21.5 11 21.0523 11 20.5V13L3.5 13C2.94772 13 2.5 12.5523 2.5 12C2.5 11.4477 2.94772 11 3.5 11L11 11V3.5C11 2.94772 11.4477 2.5 12 2.5Z"
            />
        </SvgStyled>
    );
};

export default Plus_md;
